import { Alert, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type Props = {
  fields?: (string | undefined)[]
}

const joinFields = (fields: (string | undefined)[]) => {
  if (fields.length === 1) {
    return fields[0]
  }
  const lastField = fields.at(fields.length - 1)
  const joined = fields.slice(0, fields.length - 1).join(', ')

  return joined.concat(` ${i18n.t('contract_versions.cues_alert.and')} `).concat(lastField || '')
}

const ContractCuesAlert = ({ fields }: Props) => {
  if (fields && fields.length > 0) {
    return (
      <Alert color="warning">
        <Text.Normal size="300" weight="medium">
          {i18n.t('contract_versions.cues_alert.title')}
        </Text.Normal>
        <Text.Normal weight="normal" size="200">
          {i18n.t('contract_versions.cues_alert.description_1')}{' '}
          <Text.Normal weight="medium" size="200">
            {joinFields(fields)}
          </Text.Normal>{' '}
          {i18n.t('contract_versions.cues_alert.description_2')}
        </Text.Normal>
      </Alert>
    )
  }
  return null
}

export default ContractCuesAlert
